import { PageModel, createInitialPageModel, PageStatus } from "../../../shared/model/page-model";
export type LoginPageSubStatus = "Ready" | "Resend Verification Succeeded";
export type LoginPageStatus = PageStatus | LoginPageSubStatus;

export interface LoginPageModel extends PageModel {
  showResendVerificationButton: boolean;
  subStatus: LoginPageSubStatus;
}

export function createInitialLoginPageModel(): LoginPageModel {
  return { ...createInitialPageModel(), showResendVerificationButton: false, subStatus: "Ready" };
}
